import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import HospitalDetails from "../../../HospitalData/HospitalDetails";
import physiotherapy from '../../../Assets/About/physiotherapy.svg';
import './About.css';

const About = () => {

    useEffect(() => {
        AOS.init({
                duration: 1000,
            });
        AOS.refresh();
      }, []);
    return (
        <section className="about-wrapper">
            <Container>
                <Row>
                    <Col md={12} lg={6}>
                        <div className="about-left">
                            <img src={physiotherapy} alt="img" className="img-fluid" />
                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <div className="mt-5 mt-lg-0">
                            <div className="about-content text-start" data-aos="zoom-in">
                                <h1>{HospitalDetails.hospitalName}</h1>
                                <p>Discover the pinnacle of physiotherapy care at Curative Physio, where we excel in delivering exceptional treatment. Our experts are dedicated to your well-being, ensuring a path to optimal health and vitality. Experience the future of rehabilitation with us.</p>
                            </div>
                            <div className="achievement" data-aos="fade-right">
                                <div className="single-fun">
                                    <span>500</span>
                                    <span>+</span>
                                    <p>Happy Patients</p>
                                </div>
                                <div className="single-fun sp-fun" data-aos="fade-right">
                                    <span>2</span>
                                    <span>+</span>
                                    <p>Qualified Doctors</p>
                                </div>
                                <div className="single-fun" data-aos="fade-left">
                                    <span>2</span>
                                    <span>+</span>
                                    <p>Years Experience</p>
                                </div>
                                <div className="single-fun sp-fun" data-aos="fade-left">
                                    <span>10</span>
                                    <span>+</span>
                                    <p>Physio Awards</p>
                                </div>
                                <span className="line"></span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default About;